import React, { useEffect, useState } from 'react';
import Row from '@amzn/meridian/row';
import Select, { SelectOption } from '@amzn/meridian/select';
import AgileUploadRow from '@components/agile/types/AgileUploadRow';
import { ICellRendererParams } from 'ag-grid-community';
import { storeSubcategory } from '@components/agile/types/AgileMacroplanogramTypes';
import Icon from '@amzn/meridian/icon';
import { ERROR_COLOR } from '@constants/values';
import infoKnockoutTokens from '@amzn/meridian-tokens/base/icon/info-knockout';
import Tooltip from '@amzn/meridian/tooltip';

const SubCategoriesCellRenderer = (params: {
  node: ICellRendererParams;
  setRowData: (value: AgileUploadRow[]) => void;
  rowData: AgileUploadRow[];
  setTotalNewFacings: (value: number) => void;
  setRecommendationFlag: (value: boolean) => void;
  value: storeSubcategory[];
}) => {
  const { node, setRowData, rowData, setRecommendationFlag, value } = params;
  // eslint-disable-next-line max-len
  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument,@typescript-eslint/no-unsafe-member-access
  const [selectedCategory, setSelectedCategory] = useState<string>(node.data.subcategoryId);
  const [errorFlag, setErrorFlag] = useState(!selectedCategory);

  const onClick = (subCategoryId: string) => {
    setSelectedCategory(subCategoryId);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { data } = node;
    const tempData = [...rowData];
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const rowIndex = tempData.findIndex((item) => item.asin === (data.asin as string));
    tempData[rowIndex].subcategoryId = subCategoryId;
    setRowData(tempData);
    setErrorFlag(false);
  };

  useEffect(() => {
    if (value.length > 1) {
      setRecommendationFlag(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Row spacing="none" spacingInset="none" maxWidth="50">
      <Select value={selectedCategory} onChange={onClick} width={130} error={errorFlag}>
        {value.map((subcategory) => (
          <SelectOption
            value={subcategory.subcategoryId}
            label={subcategory.subcategoryName}
            key={subcategory.subcategoryId}
          />
        ))}
      </Select>
      {errorFlag ? (
        <Tooltip position="end" title="Please select a subcategory" id="myTooltip">
          <Icon className={ERROR_COLOR} tokens={infoKnockoutTokens} />
        </Tooltip>
      ) : null}
    </Row>
  );
};

export default SubCategoriesCellRenderer;
